export default __webpack_public_path__ + "static/kamil-3366f43582e831abea03839e0b3e1fa7.jpg";